import { CSSProperties, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import UIConfig from '@/UIConfig.ts';

interface EditPopupOverlayProps extends PropsWithChildren {
  open: boolean;
}

const EditPopupOverlay = ({ open, children }: EditPopupOverlayProps) => {
  if (!open) return null;

  return createPortal(
    <div style={overlayStyle}>{children}</div>,
    document.body
  );
};

const overlayStyle: CSSProperties = {
  position: 'fixed',
  top: 100,
  left: 0,
  width: '100%',
  height: 'calc(100vh - 100px)',
  backgroundColor: UIConfig.Colors.BackgroundWhite,
  zIndex: 999,
  overflow: 'auto'
};

export default EditPopupOverlay;
